import type { QueryMetaErrorOptions } from "./types.ts";

export function readQueryMetaErrorOptions(
  meta: Record<string, unknown> | undefined,
): QueryMetaErrorOptions {
  if (!meta) {
    return {};
  }

  const errorMessage =
    typeof meta.errorMessage === "string" ||
    typeof meta.errorMessage === "function"
      ? (meta.errorMessage as QueryMetaErrorOptions["errorMessage"])
      : undefined;

  const showError =
    typeof meta.showError === "boolean" ? meta.showError : undefined;

  return { errorMessage, showError };
}
